import React, { PropsWithChildren, useContext } from "react";
import { MasterContext } from "src/lib/masterContext";
import styled from "styled-components";

export interface FlavouredStylesProps {
  $fontFamily: string;
  mainColor: string;
  dashlineColor: string;
}

export const FlavorStylesWrapper = styled.div<FlavouredStylesProps>`
  --aifi-font-family: ${(props) => props.$fontFamily};
  font-family: ${(props) => props.$fontFamily};

  min-height: inherit;

  .btn-secondary {
    background: ${(props) => props.mainColor};
    border-color: ${(props) => props.mainColor};
  }

  a {
    color: inherit;
  }
`;

export const FlavorStyles: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const { flavor } = useContext(MasterContext);

  return (
    <FlavorStylesWrapper
      $fontFamily={flavor.getFontFamily()}
      mainColor={flavor.getMainColor()}
      dashlineColor={flavor.getDashLineColor()}
    >
      {children}
    </FlavorStylesWrapper>
  );
};
